/**
 * Datas em texto `YYYY-MM-DD` das etapas 2 e 3. Nada aqui passa por `new Date(texto)`: o texto
 * puro não desloca o dia pelo fuso, e comparar texto com texto é comparar datas.
 */

/** `2026-11-30` → `30/11/2026`. */
export const formatarData = (iso: string): string => {
  const [ano, mes, dia] = iso.slice(0, 10).split('-');
  return `${dia}/${mes}/${ano}`;
};

/** Texto no formato certo e que existe no calendário (31/02 não vale). */
export const ehDataReal = (texto: string): boolean => {
  const partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
  if (!partes) return false;
  const [ano, mes, dia] = [Number(partes[1]), Number(partes[2]), Number(partes[3])];
  const data = new Date(Date.UTC(ano, mes - 1, dia));
  return data.getUTCFullYear() === ano && data.getUTCMonth() === mes - 1 && data.getUTCDate() === dia;
};

/** Hoje em São Paulo, no mesmo formato do servidor. */
export const hojeEmTexto = (): string =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });

export const MENSAGEM_DE_DATA = 'Use o formato AAAA-MM-DD com uma data que existe. Ex.: 2026-03-12';
